import React from 'react'
export type Props = {
  children?: React.ReactNode
}
export const Content = (props: Props): React.ReactElement<'div'> => {
  const { children } = props
  return <div className="Panel_Content">{children}</div>
}
export default Content
